import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_tree_select, {
      multiple: false,
      placeholder: _ctx.placeholder,
      fieldNames: { label: 'name',  value: 'id' },
      "tree-data": _ctx.orgTreeData,
      value: _ctx.value,
      disabled: _ctx.disabled,
      treeDefaultExpandAll: true,
      class: "w100",
      "show-search": "",
      onChange: _ctx.onChange,
      onSelect: _ctx.onSelect
    }, null, 8, ["placeholder", "tree-data", "value", "disabled", "onChange", "onSelect"])
  ]))
}